var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "generate-btn-box", class: {} }, [
    _c(
      "div",
      {
        staticClass: "generate-btn",
        class: {
          glow: this.btnActive === true && _vm.complete !== true,
          disabled: _vm.loading === true || this.btnActive === false,
        },
        on: { click: _vm.start },
      },
      [
        !_vm.loading
          ? _c("i", { staticClass: "far fa-wand font-size-150" })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("i", { staticClass: "fa fa-spin btn-loading-animation" })
          : _vm._e(),
        _vm._v("\n    " + _vm._s(_vm._f("trans")("Generate")) + "\n\n    "),
        _c(
          "div",
          { staticClass: "credit-cost-badge" },
          [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.totalCost)),
            ]),
            _vm._v(" "),
            _c("CoinSVG"),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }